import { RouterModule, Routes } from '@angular/router';
import { StaffAuthGuard } from './auth/guards/staff-auth-guard.service';
import { PetOwnerAuthGuard } from './auth/guards/pet-owner-auth-gurad.service';
import { ExternalUserAuthGuard } from './auth/guards/external-user-auth-guard.service';
import { RouteGuard } from './auth/guards/route-guard';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

const appRoutes: Routes = [
  { path: '', component: AppComponent, canActivate: [RouteGuard], pathMatch: 'full' },
  {
    path: 'anonymous', loadChildren: './anonymous/anonymous.module#AnonymousModule'
  },
  {
    path: 'public', loadChildren: './public/public.module#PublicModule'
  },
  {
    path: 'auth', loadChildren: './auth/authorization.module#AuthorizationModule'
  },
  {
    path: 'staff', canLoad: [StaffAuthGuard], loadChildren: './staff/staff.module#StaffModule'
  },
  {
    path: 'owner', canLoad: [PetOwnerAuthGuard], loadChildren: './pet-owner/pet-owner.module#PetOwnerModule'
  },
  {
    path: 'external', canLoad: [ExternalUserAuthGuard], loadChildren: './external/external.module#ExternalModule'
  },
  { path: 'tag', loadChildren: './finder-details/finder-details.module#FinderDetailsModule' },
  {
    path: '**', component: PageNotFoundComponent
  }
];

export const routing = RouterModule.forRoot(appRoutes);
